export * from './auth-resource.module';
export * from './auth-resource.service';
